import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab } from 'Core/components';
import * as CoreComponents from 'Core/components';
import POAddEditForm from './pomasters-add-edit-form';
import POItemsTable from './po-items-table';
import POItemReleaseTable from './po-item-release-table';
import { POService } from '../../service/api/po-service';
import { ReceivingShipmentService } from '../../service/api/receiving-shipment-service';
import { Button } from 'react-bootstrap';
import POShipmentsModal from './po-shipment-modal';
import POItemShipmentsModal from './po-item-shipment-modal';
import POReleaseShipmentsModal from './po-release-shipment-modal';



const POAddEdit = ({ showModal, modalData, onCloseModal }) => {
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [itemReleases, setItemReleases] = useState([]);
  const [loadingReleases, setLoadingReleases] = useState(false);
  // New modal states
  const [showPOShipmentsModal, setShowPOShipmentsModal] = useState({ show: false, id: null });
  const [showPOItemShipmentsModal, setShowPOItemShipmentsModal] = useState({ show: false, id: null });
  const [showPOReleaseShipmentsModal, setShowPOReleaseShipmentsModal] = useState({ show: false, id: null });

  useEffect(() => {
    if (showModal) {
      setActiveTab(0);
      setSelectedItemId(null);
      setItemReleases([]);
    }
  }, [showModal]);



  if (!modalData) return <div style={{ padding: 40, textAlign: 'center' }}>Loading...</div>;

  const handleSelectItem = async (itemId) => {
    setSelectedItemId(itemId);
    setActiveTab(2);
    setLoadingReleases(true);
    try {
      const response = await POService.getItemReleases(itemId);
      if (response.status === 200 && Array.isArray(response.response)) {
        setItemReleases(response.response);
      } else {
        setItemReleases([]);
      }
    } catch (error) {
      setItemReleases([]);
    } finally {
      setLoadingReleases(false);
    }
  };

  // New handlers for each modal
  const handleViewPOShipments = (poId) => setShowPOShipmentsModal({ show: true, id: poId });
  const handleViewPOItemShipments = (poItemId) => setShowPOItemShipmentsModal({ show: true, id: poItemId });
  const handleViewPOReleaseShipments = (poReleaseId) => setShowPOReleaseShipmentsModal({ show: true, id: poReleaseId });

  return (
    <>
      <Modal
        id="po-modal"
        show={showModal}
        size="xl"
        dialogClassName="modal-90w"
        title={'PO Details'}
        handleClose={onCloseModal}
        body={() => (
          <Tabs activeIndex={activeTab} onTabChange={setActiveTab} id="po-details-tabs">
            <Tab title="PO Details">
              <POAddEditForm data={modalData} shipmentContext={{ type: 'po' }} onViewShipments={() => handleViewPOShipments(modalData?.poId)} />
            </Tab>
            <Tab title="PO Items">
              <POItemsTable data={modalData?.items || []} onSelectItem={handleSelectItem} onViewShipments={id => handleViewPOItemShipments(id)} />
            </Tab>
            <Tab title="PO Item Release">
              {selectedItemId ? (
                loadingReleases ? (
                  <div className="text-center p-4">Loading releases...</div>
                ) : (
                  <POItemReleaseTable data={itemReleases} onViewShipments={id => handleViewPOReleaseShipments(id)} />
                )
              ) : (
                <div className="text-center p-4">
                  Select an item from the 'PO Items' tab to view its releases.
                </div>
              )}
            </Tab>
          </Tabs>
        )}
      />
      {/* New modals for each context */}
      <POShipmentsModal
        show={showPOShipmentsModal.show}
        poId={showPOShipmentsModal.id}
        onClose={() => setShowPOShipmentsModal({ show: false, id: null })}
      />
      <POItemShipmentsModal
        show={showPOItemShipmentsModal.show}
        poItemId={showPOItemShipmentsModal.id}
        onClose={() => setShowPOItemShipmentsModal({ show: false, id: null })}
      />
      <POReleaseShipmentsModal
        show={showPOReleaseShipmentsModal.show}
        poReleaseId={showPOReleaseShipmentsModal.id}
        onClose={() => setShowPOReleaseShipmentsModal({ show: false, id: null })}
      />
    </>
  );
};

POAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.object,
  onCloseModal: PropTypes.func,
};

export default POAddEdit;
